// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_Cqb","alignRight":"e_Dqb","alignLeft":"e_Eqb","item":"e_Fqb","icon":"e_Gqb","soft":"e_Hqb"};